import { httpRequest } from '@/utils/axios';
export const fetchAddWish = (data: { product_id: number | number[] }) =>
  httpRequest('POST:/api/customer/wish', { data });
export const fetchCancelWish = (data: { product_id: number[] }) =>
  httpRequest('DELETE:/api/customer/wish', { data });
